import React from "react";
import UserForm from "./components/UserForm";
import ApiTokens from "./components/ApiTokens";

const Settings = () => {
  return (
      <div className="space-y-4">
        <UserForm/>
        <ApiTokens/>
      </div>
  )
}

export default Settings
